/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Button, Form, FormGroup, Label, Input, Col } from 'reactstrap';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext'

// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

const ReplaceProvider = props => {

    // states
    const [isLoading, setIsLoading] = useState(false);
    const [providers, setProviders] = useState([]);
    const [newProvider, setNewProvider] = useState('');
    const [clientEmail, setClientEmail] = useState('');

    // contexts
    const { theme } = useContext(ThemeContext);

    // use Effects
    useEffect(() => {
        AdminService.getProviders(null, null, null).then(data => {
            try {
                setProviders(data.providers);
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                GeneralService.logError('at Admin ReplaceProvider useEffect', 'Error in try catch block', err.stack);
            }
        });
        return () => { setProviders(); setNewProvider(); setClientEmail(); }
    }, []);

    // handle functions
    const handleSubmit = e => {
        e.preventDefault();
        try {
            if (newProvider === "") {
                return;
            }
            setIsLoading(true);
            AdminService.replaceProvider(clientEmail, providers[newProvider]._id).then(data => {
                setClientEmail("");
                setNewProvider("");
                Alert.info(data.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading(false);
            }).catch(error => {
                Alert.error(error.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading(false);
            });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading(false);
            GeneralService.logError('at Admin ReplaceProvider handleSubmit', 'Error in try catch block', err.stack);
        }
    }

    return (
        <main>
            <div className="container-fluid">
                <h3 className="my-4">Replace Counsellor</h3>
                <div className="card mb-4">
                    <div className="card-header">
                        Replace the current allocated Counsellor of Client
                    </div>
                    <div className="card-body">
                        <Form onSubmit={handleSubmit}>
                            <label className="mb-4">
                                Enter the client’s email whose counsellor needs to be replaced. Then select a new counsellor from the dropdown below.
                            </label>
                            <FormGroup row>
                                <Label sm={3} for="clientEmail">Client’s Email</Label>
                                <Col sm={6}>
                                    <Input type="text" name="clientEmail" id="clientEmail" value={clientEmail} onChange={(e) => setClientEmail(e.target.value)} required />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={3} for="providers">Counsellors</Label>
                                <Col sm={6}>
                                    <Input type="select" name="providers" id="providers" value={newProvider} onChange={(e) => setNewProvider(e.target.value)} required>
                                        <option value="">Select one</option>
                                        {
                                            providers.map((item, index) => (
                                                <option key={index} value={index}>{item.title ? item.title : ''} {item.firstName} {item.lastName}</option>
                                            ))
                                        }
                                    </Input>
                                </Col>
                            </FormGroup>
                            <Button type="submit" className="btn mt-2" style={theme.button} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Replace Counsellor</Button>
                        </Form>
                    </div>
                </div>
            </div>
        </main>
    )

}

export default ReplaceProvider;